var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcanSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0H13C14.1046 0 15 0.814028 15 1.81818V2.72727H18C19.1046 2.72727 20 3.5413 20 4.54545V6.36364C20 7.36779 19.1046 8.18182 18 8.18182H17.9199L17 18.1819C17 19.186 16.1046 20.0001 15 20.0001H5.00005C3.89548 20.0001 3.00005 19.186 3.0035 18.2574L2.07991 8.18182H2C0.895431 8.18182 0 7.36779 0 6.36364V4.54545C0 3.5413 0.895431 2.72727 2 2.72727H5V1.81818C5 0.814028 5.89543 0 7 0ZM5.0001 18.1819L4.08659 8.18191H15.9133L15.0036 18.1064L15.0001 18.1819H5.0001ZM2 6.3637V4.54551H18V6.3637H2ZM13 1.81818V2.72727H7V1.81818H13ZM6.29281 10.6429L7.70702 9.35725L9.99991 11.4417L12.2928 9.35725L13.707 10.6429L11.4141 12.7273L13.707 14.8118L12.2928 16.0974L9.99991 14.013L7.70702 16.0974L6.29281 14.8118L8.5857 12.7273L6.29281 10.6429Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanSvg);
export default __webpack_public_path__ + "static/media/trashcanSVG.ff91badf46217c0973b1091de06689b2.svg";
export { ForwardRef as ReactComponent };